export const FETCH_VENDOR_DATA="Fetch_Vendor_Data"
export const FETCH_VENDOR_DATA_SUCCESS = "Fetch_Request_Success";
export const FETCH_VENDOR_DATA_FAILURE = 'Fetch_Request_Failed';

export const fetchVendorData = (data) => {
    return {
        type: FETCH_VENDOR_DATA,
        data
    }
}

export const fetchVendorDataSuccess = (data) => {
    return {
        type: FETCH_VENDOR_DATA_SUCCESS,
        data
    }
}
export const fetchVendorDataFailure = (error) => {
    return {
        type: FETCH_VENDOR_DATA_FAILURE,
        error
    }
}